'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _i18n = require('../join/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

require('./index.scss');

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Coupon = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Coupon, _React$PureComponent);

    function Coupon() {
        (0, _classCallCheck3.default)(this, Coupon);
        return (0, _possibleConstructorReturn3.default)(this, (Coupon.__proto__ || Object.getPrototypeOf(Coupon)).apply(this, arguments));
    }

    (0, _createClass3.default)(Coupon, [{
        key: 'render',
        value: function render() {
            var data = this.props.data;


            return _react2.default.createElement(
                'div',
                { className: 'coupon-detail' },
                _react2.default.createElement('div', { className: 'login-logo' }),
                _react2.default.createElement(
                    'div',
                    { className: 'coupon-detail-top' },
                    _react2.default.createElement(
                        'div',
                        { className: 'result-status' },
                        _react2.default.createElement('div', { className: 'success-mark' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'welcome' },
                            data.returnObject.title
                        ),
                        _react2.default.createElement('div', { className: 'fail-tip', dangerouslySetInnerHTML: { __html: data.returnObject.failTip } })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'coupon-detail-bottom' },
                    data.success ? _react2.default.createElement(
                        'div',
                        { className: 'coupon-content' },
                        _react2.default.createElement('div', { className: 'receive-desc', dangerouslySetInnerHTML: { __html: data.returnObject.successTip } }),
                        _react2.default.createElement(
                            'div',
                            { className: 'coupon-display', style: { background: 'url(' + data.returnObject.couponImgUrl + ') no-repeat', backgroundSize: 'cover' } },
                            _react2.default.createElement(
                                'div',
                                { className: 'amount' },
                                data.returnObject.denomination
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'order-amount' },
                                data.returnObject.orderAmountLimit
                            )
                        )
                    ) : null,
                    _react2.default.createElement(
                        'a',
                        { className: 'shop-now', href: '//sale.aliexpress.com/new_user_channel.htm' },
                        _i18n2.default.SHOP_NOW
                    )
                )
            );
        }
    }]);
    return Coupon;
}(_react2.default.PureComponent), _class.propTypes = {
    /**
     * 优惠券接口返回的数据
     */
    data: _propTypes.PropTypes.object
}, _temp);
exports.default = Coupon;